import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../redux/UserLogin/UserState";
import { CheckUserType } from "../Utils/Auth";
import { ToastContainer, toast } from "react-toastify";
import isEmail from "validator/lib/isEmail";
import { LoginAuth, resetPassword } from "../Utils/userFunctions";
function Login() {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false)
  const [user_name_error, setUser_name_error] = useState("");
  const [password_error, setPassword_error] = useState("");
  const [showForgot, setShowForgot] = useState(false);
  const [showLogin, setShowLogin] = useState(true);
  const [email, setEmail] = useState("");
  const [email_error, setEmail_error] = useState("");
  const [resetSuccess, setResetSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const login = async () => {
    if (username.length === 0) {
      setUser_name_error("Username can not be empty!");
    } else if (password.length === 0) {
      setPassword_error("Password can not be empty!");
    } else {
      const formData = new FormData();
      formData.append("email", username);
      formData.append("password", password);
      const response = await LoginAuth(formData);
      if (response.token) {
        console.log(response)
        dispatch(loginSuccess({ login: true }));
        localStorage.setItem(
          "login",
          JSON.stringify({
            login: true,
            token: response.token,
            user_type: response.user_type,
          })
        );
        let user_type = CheckUserType();
        localStorage.setItem("user_type", user_type);
        localStorage.setItem("first_name", response.first_name);
        if (user_type === 4) { //usertype 4 is for subadmin
          navigate("/AdminListManufacturer");
        } else if (user_type === 3 || user_type === 2) {
          navigate("/UserDashboard"); //usertype 3r and 2 is for primary and secondary user
        } else if (user_type === 1) { //usertype 1 is for admin
          navigate("/ManageAdministratorUser");
        } else if (user_type === 5) { //usertype 5 is for quality supervisor
          navigate("/manage-participants");
        }
      } else {
        toast.error(response.message, { autoClose: 1500 });
      }
    }
  };

  const forGotForm = (e) => {
    e.preventDefault();
    setShowForgot(true);
    setShowLogin(false);
    setResetSuccess(false);
  };
  const loginForm = (e) => {
    e.preventDefault();
    setShowForgot(false);
    setShowLogin(true);
    setResetSuccess(false);
  };
  const handleForgotPasword = async () => {
    const formData = new FormData();
    if (email.length === 0) {
      setEmail_error("Please enter email Id");
    } else if (isEmail(email) === false) {
      setEmail_error("Please enter valid email Id");
    } else {
      setEmail_error("");
      formData.append("email", email);
      const response = await resetPassword(formData);
      if (response.status === "success") {
        setResetSuccess(true);
        setMessage(response.message);
      } else {
        setResetSuccess(false);
        setEmail_error(response.message);
      }
    }
  };
  return (
    <div className="row m-0">
      <ToastContainer />
      <div className="col-md-5 col-lg-5 col-sm-5 bg-image login_left_bg">
        <div className="auth-content-section">
          <h2 className="text-white">
            <b>Single platform to manage all your PMCF surveys</b>
          </h2>
          <p className="text-white">
            FastPMCF
            <sup>
              <sup>TM</sup>
            </sup>
            manages end to end cycle of the PMCF survey and enables medical
            device manufacturers to get feedback on clinical evidence from
            market in a quick turnaround time.
          </p>
        </div>
      </div>
      <div className="col-sm-7">
        <div className="login_right_div">
          <div className="row">
            <div className="col-md-2 col-lg-2 col-sm-2"></div>
            <div className="col-md-8 col-lg-8 col-sm-8">
              <div className="logo">
                <img
                  src={require("../Assets/Images/logo.png")}
                  alt="N/A"
                  height="100"
                />
              </div>
              {showLogin && (
                <div className="login_form">
                  <div className="we-heading">
                    <h2 className="text-center">
                      <b>Login</b>
                    </h2>
                  </div>
                  <div className="login_right_div_2">
                    <div className="auth-form">
                      <div className="form-group">
                        <div className="input-group mb-2 mr-sm-2">
                          <div className="input-group-prepend">
                            <div className="input-group-text">
                              <img
                                className="text-center img_style"
                                src={require("../Assets/Images/email.png")}
                                alt="N/A"
                                height="40"
                              />
                            </div>
                          </div>
                          <input
                            autoComplete="new-password"
                            type="text"
                            value={username}
                            className="form-control input_email"
                            onChange={(e) => {
                              setUsername(e.target.value);
                              setUser_name_error("");
                            }}
                            placeholder="Email ID"
                          ></input>
                        </div>
                        <p style={{ color: "red" }}>{user_name_error}</p>
                      </div>

                      <div className="form-group">
                        <div className="input-group mb-2 mr-sm-2">
                          <div className="input-group-prepend">
                            <div className="input-group-text">
                              <img
                                className="text-center img_style"
                                src={require("../Assets/Images/pass.png")}
                                alt="N/A"
                                height="40"
                              />
                            </div>
                          </div>
                          <input
                            autoComplete="new-password"
                            type={showPassword?"text":"password"}
                            value={password}
                            className="form-control input_email"
                            onChange={(e) => {
                              setPassword(e.target.value);
                              setPassword_error("");
                            }}
                            style={{position:'relative'}}
                            placeholder="Password"
                          ></input>
                          <i onClick={()=>setShowPassword(prev=>!prev)} class={`fa ${showPassword?'fa-eye-slash':'fa-eye'}`} aria-hidden="true" style={{position:"absolute", right:0, top:'50%', translate:'-100% -50%', fontSize:'1.2rem', color:'grey', zIndex:'10', cursor:'pointer'}}></i>
                        </div>
                        <p style={{ color: "red" }}>{password_error}</p>
                      </div>
                      <div className="form-group mt-5">
                        <button className="auth-btn" onClick={login}>
                          Login
                        </button>
                      </div>
                      <div className="form-group text-center">
                        <span className="forgot-text" onClick={forGotForm}>
                          <p>Forgot Password?</p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showForgot && !resetSuccess && (
                <div className="reset_form">
                  <div className="we-heading cus_hide">
                    <h2 className="text-center">
                      <b>Forgot your password?</b>
                    </h2>
                  </div>
                  <div className="we-form-box">
                    <div className="auth-form">
                      <div className="we-heading cus_hide">
                        <p className="text-center">
                          Please enter your registered email address.
                          <br />
                          We will send you an email with instructions to reset
                          your password.
                        </p>
                      </div>
                      <div className="message mb-5"></div>
                      <div className="form-group">
                        <div className="input-group mb-2 mr-sm-2">
                          <div className="input-group-prepend">
                            <div className="input-group-text">
                              <img
                                className="text-center img_style"
                                src={require("../Assets/Images/email.png")}
                                alt="N/A"
                                height="40"
                              />
                            </div>
                          </div>
                          <input
                            type="email"
                            value={email}
                            className="form-control input_email"
                            onChange={(e) => {
                              setEmail(e.target.value);
                              setEmail_error("");
                            }}
                            placeholder="Email ID"
                          ></input>
                        </div>
                        <p style={{ color: "red" }}>{email_error}</p>
                      </div>
                      <div className="form-group mt-5">
                        <button
                          className="auth-btn"
                          onClick={handleForgotPasword}
                        >
                          Reset Password
                        </button>
                      </div>
                      <div className="form-group text-center">
                        <span
                          className="forgot-text text-center"
                          onClick={loginForm}
                        >
                          <p>{"<"} Back to Login?</p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {resetSuccess && (
                <>
                  <div className="message mb-5">
                    <span className="text-success">{message}</span>
                  </div>
                  <p className="forgot-text text-center">
                    <button className="auth-btn" onClick={loginForm}>
                      Login
                    </button>
                  </p>
                </>
              )}
            </div>
            <div className="col-md-2 col-lg-2 col-sm-2"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
